import { configureStore } from "@reduxjs/toolkit";
import analyticsReducer, { analyticsApi } from "./analytics";
import { authApi } from "./auth/authService";
import formReducer, { formsApi } from "./formService";
import paramReducer, { paramApi } from "./paramService";
import paymentReducer, { paymentApi } from "./paymentService";
import { redevableApi } from "./redevableService";
import redevancesReducer, { redevanceApi } from "./redevanceService";
import { eventService } from "./services/eventService";
import usersReducer, { userApi } from "./userServices";

const store = configureStore({
    reducer: {
        payment: paymentReducer,
        analytics: analyticsReducer,
        Form: formReducer,
        param: paramReducer,
        redevances: redevancesReducer,
        redevable: redevableApi.reducer,
        eventService: eventService.reducer,
        users: usersReducer,
        [eventService.reducerPath]: eventService.reducer,
        [redevableApi.reducerPath]: redevableApi.reducer,
        [redevanceApi.reducerPath]: redevanceApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [paymentApi.reducerPath]: paymentApi.reducer,
        [analyticsApi.reducerPath]: analyticsApi.reducer,
        [formsApi.reducerPath]: formsApi.reducer,
        [paramApi.reducerPath]: paramApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(eventService.middleware,
            redevanceApi.middleware,
            redevableApi.middleware,
            authApi.middleware,
            paymentApi.middleware,
            analyticsApi.middleware,
            formsApi.middleware,
            paramApi.middleware,
            userApi.middleware,
        ),
});

export default store;